import React from 'react'
import { Navigate } from 'react-router-dom'

export const HumanProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem('human_access_token')
  if (!token) return <Navigate to="/human/login" replace />
  return <>{children}</>
}

export const HumanPublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem('human_access_token')
  if (token) return <Navigate to="/human/workspace" replace />
  return <>{children}</>
}
